@let panelsBefore = panelsBeforeList();
@let panelDirs = panels();
@let isHorizontal = orientation() === 'horizontal';

<div
  ngpTabset
  [class]="tabsetClass()"
  [ngpTabsetValue]="value()"
  [ngpTabsetOrientation]="orientation()"
  (ngpTabsetValueChange)="onValueChange($event)"
>
  @if (panelsBefore) {
    @for (panel of panelDirs; track panel.value()) {
      <div
        ngpTabPanel
        [ngpTabPanelValue]="panel.value()"
        [class]="tabPanelClass"
      >
        <ng-container [ngTemplateOutlet]="panel.template"></ng-container>
      </div>
    }
  }

  <div
    ngpTabList
    [class]="tabListClass()"
  >
    @if (rect(); as rect) {
      <span
        aria-hidden="true"
        [class]="slidingBarClass()"
        [style.left.px]="isHorizontal ? rect.left : null"
        [style.width.px]="isHorizontal ? rect.width : null"
        [style.top.px]="!isHorizontal ? rect.top : null"
        [style.height.px]="!isHorizontal ? rect.height : null"
      ></span>
    }

    @for (opt of options(); track opt.value) {
      <button
        #item
        type="button"
        ngpTabButton
        [ngpTabButtonValue]="opt.value"
        [ngpTabButtonDisabled]="opt.disabled"
        [class]="tabButtonClass()"
      >
        @if (isHorizontal) {
          @if (opt.icon) {
            <ks-icon
              decorative
              [name]="opt.icon"
            ></ks-icon>
          }

          <span class="flex-auto text-left">{{ opt.label | ksTranslate }}</span>

          @if (opt.badge) {
            <ks-badge
              rounded
              size="3xs"
              [class]="tabBadgeClass"
            >
              {{ opt.badge | ksTranslate }}
            </ks-badge>
          }
        } @else {
          @if (opt.icon) {
            <span class="relative">
              <ks-icon
                decorative
                [name]="opt.icon"
              ></ks-icon>

              @if (opt.badge) {
                <ks-badge
                  rounded
                  size="3xs"
                  [class]="tabBadgeOnIconClass"
                >
                  {{ opt.badge | ksTranslate }}
                </ks-badge>
              }
            </span>
          }

          <span class="flex w-full items-center justify-center gap-2">
            @if (!opt.icon && opt.badge) {
              <span class="min-w-0 flex-auto truncate text-left">{{ opt.label | ksTranslate }}</span>

              <ks-badge
                rounded
                size="3xs"
                [class]="tabBadgeClass"
              >
                {{ opt.badge | ksTranslate }}
              </ks-badge>
            } @else {
              {{ opt.label | ksTranslate }}
            }
          </span>
        }
      </button>
    }
  </div>

  @if (!panelsBefore) {
    @for (panel of panelDirs; track panel.value()) {
      <div
        ngpTabPanel
        [ngpTabPanelValue]="panel.value()"
        [class]="tabPanelClass"
      >
        <ng-container [ngTemplateOutlet]="panel.template"></ng-container>
      </div>
    }
  }
</div>
